import { TabStyles } from '@tableau/widgets';
import React from 'react';


import { divWithStyle } from './LayoutComponents';
import {
  DataQualityDetailPanelMaxHeight as IndicatorDetailPanelMaxHeight,
  DataQualityDetailPanelWidth,
  DataQualityStatusChipBackgroundColor,
  DataQualityStatusChipSevereBackgroundColor,
  DataQualityStatusSevereTitleColor,
  DataQualityStatusTitleColor
} from './StyleConstants';
import { cssClass } from './StyleFunctions';

const Typography = TabStyles.Typography;
const Spacing = TabStyles.Spacing;
const Sizing = TabStyles.Sizing;

export const IndicatorStatusChipButtonStyle: React.CSSProperties = {
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  color: DataQualityStatusTitleColor,
  height: Sizing.RowHeight,
  fontSize: Typography.Sizing.Default,
  paddingLeft: Spacing.DefaultSpace,
  backgroundColor: DataQualityStatusChipBackgroundColor,
};

export const IndicatorStatusChipSevereButtonStyle: React.CSSProperties = {
  ...IndicatorStatusChipButtonStyle,
  color: DataQualityStatusSevereTitleColor,
  backgroundColor: DataQualityStatusChipSevereBackgroundColor
};

export const IndicatorStatusIconButtonStyle: React.CSSProperties = {
  padding: Spacing.SmallSpace,
  cursor: 'pointer',
};

export const IndicatorPanelDialogStyle: React.CSSProperties = {
  width: DataQualityDetailPanelWidth,
  maxHeight: IndicatorDetailPanelMaxHeight,
};

export const IndicatorDetailPanelDialogBodyStyle: React.CSSProperties = {
  padding: 16,
  // Set the maximum height of both the dialog and its body for IE11 compatibility.
  maxHeight: IndicatorDetailPanelMaxHeight,
};

export const IndicatorDetailContentStyle: React.CSSProperties = {
  ...IndicatorDetailPanelDialogBodyStyle,
  paddingLeft: Spacing.LargeSpace,
  paddingRight: Spacing.LargeSpace,
  overflow: 'auto',
};

export const IndicatorDetailGroupHeadingDiv = divWithStyle('DataQualityDetailGroupHeadingDiv', {
  fontWeight: 'bold',
  marginBottom: Spacing.LargeSpace,
});

export const IndicatorDetailGroupDiv = divWithStyle('DataQualityDetailGroupDiv', {
  fontSize: Typography.Sizing.Default,
  paddingLeft: 9,
  width: 255,
});

export const IndicatorDetailGroupSpacerDiv = divWithStyle('DataQualityDetailGroupSpacerDiv', {
  height: 9
});

export const IndicatorDetailStyle = divWithStyle('DataQualityDetailDiv', {
  marginBottom: Spacing.LargeSpace,
});

export const IndicatorTooltipLabelClass = cssClass('DataQualityTooltipLabelClass', {
  color: DataQualityStatusTitleColor,
  paddingLeft: Spacing.DefaultSpace,
  paddingRight: Spacing.DefaultSpace,
});

export const IndicatorStatusChipIconOnlyClass = cssClass('DataQualityStatusChipIconOnlyClass', {
  verticalAlign: 'text-bottom',
  alignContent: 'left'
});

export const IndicatorStatusChipIconClass = cssClass('DataQualityStatusChipIconClass', {
  verticalAlign: 'text-bottom'
});

export const IndicatorDetailStatusChipStyle = divWithStyle('DataQualityDetailStatusChip', {
  marginBottom: Spacing.MediumSpace
});

export const IndicatorDetailAssetStyle = divWithStyle('DataQualityDetailAsset', {
  fontWeight: 'bold',
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  marginTop: Spacing.DefaultSpace,
  marginBottom: Spacing.DefaultSpace,
  textOverflow: 'ellipsis',
  display: 'flex',
  whiteSpace: 'pre-wrap',
  overflow: 'hidden'
});

export const CertificationIconWrapperStyle = divWithStyle('CertificationIconWrapperStyle', {
  marginTop: 8,
  marginBottom: 8,
  marginRight: 4,
})

export const IndicatorDetailAuthorStyle = divWithStyle('DataQualityDetailAuthor', {
  color: Typography.Color.Secondary,
  fontSize: Typography.Sizing.Default,
  marginTop: 8,
  marginBottom: 8,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});

export const IndicatorDetailDateStyle = divWithStyle('DataQualityDetailDate', {
  color: Typography.Color.Secondary,
  fontSize: Typography.Sizing.Default,
  marginBottom: 8
});

export const indicatorDetailMessageStyle: React.CSSProperties = {
  width: 255,
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
};

export const IndicatorDetailMessageStyle = divWithStyle('DataQualityDetailMessage', {
  width: 255,
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  $nest: {
    p: {
      marginTop: 0,
      marginBottom: 16
    }
  }
});

export const IndicatorDetailPermissionRequired: React.CSSProperties = {
  color: 'rgba(0,0,0,0.56)',
};


export const IndicatorGroupHeadingDiv = divWithStyle('IndicatorGroupHeadingDiv', {
  fontWeight: 'bold',
  color: '#4F4F4F',
  marginBottom: 8,
  fontSize: Typography.Sizing.Default,
});

export const IndicatorAssetGroupDiv = divWithStyle('IndicatorAssetGroupDiv', {
  paddingLeft: 12,
  fontSize: Typography.Sizing.Default,
});

export const IndicatorIndicatorsGroupDiv = divWithStyle('IndicatorIndicatorsGroupDiv', {
  paddingLeft: 28,
});


export const IndicatorAssetChildGroupDiv = divWithStyle('IndicatorAssetChildGroupDiv', {
  marginLeft: -12,
  fontSize: Typography.Sizing.Default,
});
